import React from 'react';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import '../../public/css/Checkout.css';
import navigateBack from '../../public/images/icons/navigate-back.png';
import defaultMsg from '../../translations/lang/en-US.json';

class CheckoutLayout extends React.Component {
  render() {
    const imageStyles = {
      height: '20px',
      marginRight: '10px',
      marginBottom: '-5px',
    };

    return (
      <div className="main-container containerPostion checkout-container-wrapper">
        <nav
          className="navbar navbar-default checkout-flat-nav checkout-navbar"
          id="mainHeader"
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 ">
                <div className="checkout-back-to-menu">
                  <Link to={'/' + this.props.params.rname}>
                    <img style={imageStyles} src={navigateBack} alt="icon" />
                    <span
                      className="hidden-xs"
                      style={{ verticalAlign: 'sub' }}
                    >
                      <FormattedMessage
                        id="backToMenu"
                        defaultMessage={defaultMsg.backToMenu}
                      />
                    </span>
                  </Link>
                </div>
                <div className="checkout-page-title">
                  <FormattedMessage
                    id="checkout"
                    defaultMessage={defaultMsg.checkout}
                  />
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className="container checkout-container">
          {this.props.children}
        </div>
      </div>
    );
  }
}

export default CheckoutLayout;



// WEBPACK FOOTER //
// ./src/views/layouts/CheckoutLayout.jsx